import { session } from "~/clientInstance";

export interface getGitHubAppSettingsResult {
    canUseGitHubApp: boolean;
    canUseTrustedFlow: boolean;
}

export function getGitHubAppSettings(): getGitHubAppSettingsResult {
    const gitHubSettings = session.gitHubAppSettings;

    return {
        canUseGitHubApp: gitHubSettings?.CanUseGitHubApp ?? false,
        canUseTrustedFlow: gitHubSettings?.CanUseTrustedFlow ?? false,
    };
}

export function isGitHubAppEnabled(): boolean {
    return getGitHubAppSettings().canUseGitHubApp;
}

export function isGitHubAppTrustedFlow(): boolean {
    return getGitHubAppSettings().canUseTrustedFlow;
}
